import { render } from "./PopUpShareStudentCredentials.vue?vue&type=template&id=4fafecd8&scoped=true"
import script from "./PopUpShareStudentCredentials.vue?vue&type=script&lang=js"
export * from "./PopUpShareStudentCredentials.vue?vue&type=script&lang=js"

import "./PopUpShareStudentCredentials.vue?vue&type=style&index=0&id=4fafecd8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fafecd8"]])

export default __exports__